import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';

import RecommendScore   from '@common/influencer/parts/recommend-score';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


const DIGITAL_CLONE_URL = 'https://persona.aiqlab.com/';

class InfluencerBasis extends React.Component {
  render() {
    let data = this.props.data;
    
    let inside = [];
    
    if( data.gender == null && data.manual_gender != null ) data.gender = data.manual_gender;
    if( data.gender != null ){
      inside.push({ name: '性別', value: (data.gender == 1) ? '男性' : '女性' });
    } else {
      inside.push({ name: '性別', value : '不明' });
    }
    
    if( data.generation == null && data.manual_generation != null ) data.generation = data.manual_generation;
    if( data.generation != null ){
      inside.push({ name: '年代', value: (data.generation +'0代') });
    } else {
      inside.push({ name: '年代', value : '不明' });
    }
    
    if( data.thumbnail == null ) data.thumbnail = '/images/default.jpg';
    
    // デジタルクローン判定
    let is_digital_clone = 0;
    try { is_digital_clone = data.status.is_digital_clone; } catch(e) {}
    
    return (
      <div className="influencer-basis">
        <div className="thumbnail">
          <a href={'https://www.instagram.com/'+ data.insta_id} target="_blank"><img src={data.thumbnail} /></a>
        </div>
        <div className="profile-box">
          <div className="user-contents">
            <div className="user-name">
              <h5>@{data.insta_id}</h5>
              <h3>{data.full_name}</h3>
            </div>
            {/*<div className="user-inside">
              { inside.map((d, key) => {
                return (
                  <div key={key} className="inside">
                    <h6>{d.name}</h6>
                    <h3>{d.value}</h3>
                  </div>
                );
              })}
            </div>*/}
          </div>
          
          <div className="user-contents">
            <div className="user-score">
              <div className="score-item">
                <h3>{Utils.viewScore(data.post_count)}<span>件</span></h3>
                <h5>投稿</h5>
              </div>
              <div className="score-item">
                <h3>{Utils.viewScore(data.followers)}<span>人</span></h3>
                <h5>フォロワー</h5>
              </div>
              <div className="score-item">
                <h3>{Utils.viewScore(data.follows)}<span>人</span></h3>
                <h5>フォロー</h5>
              </div>
            </div>
            
            { (is_digital_clone == 1) &&
              <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>デジタルクローンとチャットする</Tooltip>}>
                <a className="digital-clone-button" href={DIGITAL_CLONE_URL + data.insta_id} target="_blank">
                  <i className="material-icons">assignment_ind</i>
                  <h6>チャット</h6>
                </a>
              </OverlayTrigger>
            }
            
            {/*<div className="user-biography">
              {data.biography}
            </div>*/}
          </div>
        </div>
        
        <RecommendScore data={data} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerBasis;